<script lang="ts">
	import TextWithIcon from '../../textWithIcon/TextWithIcon.svelte'
	import { Tooltip } from '@repo/ui'
	import { type Snippet } from 'svelte'

	interface Props {
		name: string
		label?: string
		required?: boolean
		disabled?: boolean
		tooltip?: string | null
		tooltipSlot?: Snippet
		unlock?: Snippet
		action?: Snippet
		children?: Snippet
	}

	let {
		name,
		label = '',
		required = false,
		disabled = false,
		tooltip = null,
		tooltipSlot,
		unlock,
		action,
		children,
	}: Props = $props()
</script>

<div class="flex">
	<label class="inline-flex text-base font-bold" for={name}>
		{#if label}
			<TextWithIcon inline>
				<span class={disabled ? 'opacity-50' : ''}>
					{label}
				</span>
				{#if required}
					<span class={disabled ? 'opacity-50' : 'text-red-500'}>*</span>
				{/if}
				{#if tooltip || tooltipSlot}
					<Tooltip>
						{#if tooltipSlot}{@render tooltipSlot()}{:else}{tooltip}{/if}
					</Tooltip>
				{/if}

				{@render unlock?.()}
			</TextWithIcon>
		{:else}
			{@render children?.()}
			<span class="mt-5 block"></span>
		{/if}
	</label>
	{@render action?.()}
</div>

<div class="mt-1"></div>
